import { Helmet } from "react-helmet"
import Header from "../../../Components/Header"
import MainContent from './MainContent'

const SettingList = () => {
  
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
      <Helmet>
				<title>Setting List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}

export default SettingList